import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './views/tutorRoute/DashboardSolicitudesTutor';
import MisCotizaciones from './views/tutorRoute/HistorialCotizaciones';
import LoginScreen from './views/Logins/LoginScreen.jsx';
import RecursosTutor from './views/tutorRoute/recursosTutor';
import Calendario from './views/compartedRoutes/Contabilidad/Calendario';
import PagosTutor from './views/tutorRoute/PagosTutor';
import DetallesServicio from './views/compartedRoutes/Contabilidad/DetallesServicio';
import RecuperarContrasena from './views/Logins/RecuperarContrasena';
import AplicarTutor from './views/Logins/AplicarTutor';
import Formulario from './views/Logins/formulario';
import ProtectedRoute from './components/ProtectedRoute';
import HomeScreenPrincipal from './views/HomeScreenPrincipal';
import ErrorScreen from './views/Logins/ErrorScreen.jsx';
import DetallesSolicitudes from './views/compartedRoutes/solicitudes/DetallesSolicitudes.jsx';
import PerfilUsuario from './views/tutorRoute/Usuario/PerfilUsuario.jsx';
import { UsersProvider } from './metodos/userContext.js';
import { LoadingProvider } from './utils/LoadingProvider';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import DashboardSolciitudesTutor from './views/tutorRoute/DashboardSolicitudesTutor';
import ConditionalRoute from './components/ConditionalRoute';
import DashboardAdminAdmin from './views/adminRoute/DashboardAdmin';
import DashboardTesis from './views/adminRoute/Tesis/DasboardTesis';
import ConfiguracionAdmin from './views/adminRoute/Configuracion/Configuracion';
import { ConfiguracionProvider } from './metodos/ConfiguracionContext';
import NuevosTutores from './views/adminRoute/RecursosHumanos/NuevosTutores';
import ListaTutores from './views/adminRoute/RecursosHumanos/ListaTutores';
import GeneradorPruebas from './views/adminRoute/RecursosHumanos/GeneradorPruebas';
import ModuloClientes from './views/adminRoute/Clientes/ModuloClientes';
import ModuloContabilidad from './views/adminRoute/Contabilidad/ModuloContabilidad';
import TesisManager from './views/adminRoute/Tesis/TesisManager';
import ProPlataforma from './views/adminRoute/Solicitudes/proPlataforma/ProPlataforma';
import DetallesTutor from './views/adminRoute/RecursosHumanos/Tutor/DetallesTutor';
import CalendarioAdmin from './views/adminRoute/Contabilidad/CalendarioAdmin';
import HistorialCliente from './views/adminRoute/Clientes/HistorialCliente';
import DetalleProPlataforma from './views/adminRoute/Solicitudes/proPlataforma/DetalleProPlataforma';
import ModeloCuentasCobro from './views/adminRoute/CuentasCobro/ModuloCuentasCobro';
import ModuloEstadisticas from './views/adminRoute/Estadisticas/ModuloEstadisticas';
import DetallesEntregaTrabajo from './views/compartedRoutes/Contabilidad/DetallesEntregaTrabajo';
import ModuloCostos from './views/adminRoute/Contabilidad/ModuloCostos';
import Prueba from './views/tutorRoute/Usuario/Prueba';
import ModuloWhatsapp from './views/adminRoute/Whatsapp/ModuloWhatsapp';
import ModuloDashboard from './views/adminRoute/Dashboard/ModuloDashboard';
import EmbudoVentas from './views/adminRoute/Whatsapp/EmbudoVentas';
import ModuloMarketing from './views/adminRoute/Estadisticas/ModuloMarketing';
import ModuloPagos from './views/compartedRoutes/Contabilidad/ModuloPagos';
import ModuloPagosParcial from './views/adminRoute/Contabilidad/ModuloPagos';
import AgregarVariables from './views/adminRoute/CentroInformacion/AgregarVariables';
import { DialogProvider } from './components/Dialogs/Dialogprovider';
import ProPlataformaDashboard from './views/adminRoute/CentroInformacion/ProPlataformaDashboard';
import GuardadorDatos from './views/adminRoute/Guardador/guardadorDatos';
import RegistroCliente from './views/Logins/RegistroCliente';
import ConfirmarNumero from './views/Logins/Modulos/ConfirmarNumero';
import ConfirmarCorreo from './views/Logins/Modulos/ConfirmarCorreo';
import SolicitudesCLiente from './views/clienteRoute/Solicitudes/SolicitudesCliente';
import CambiarContrasena from './views/Logins/CambiarConstrasena';
import DetallesSolicitudesGuest from './views/compartedRoutes/solicitudes/DetallesSolicitudesGuest';
import PagoResultadoWompi from './views/Utils/Wompi/PagoResultadowompi';

// Componente que maneja el ajuste del viewport para iOS
function ViewportHandler() {
  useEffect(() => {
    // Solución específica para iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
    if (!isIOS) return; // Solo aplicar en iOS
    
    const handleViewportChange = () => {
      // Obtener la altura real de la ventana
      const vh = window.innerHeight * 0.01;
      // Establecer la variable CSS --vh
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      
      // También establecer altura explícita
      document.documentElement.style.height = `${window.innerHeight}px`;
      document.body.style.height = `${window.innerHeight}px`;
      
      // Forzar un reflow
      document.body.getBoundingClientRect();
    };
    
    // Ejecutar al inicio
    handleViewportChange();
    
    // Eventos para detectar cambios en la ventana
    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
      window.visualViewport.addEventListener('scroll', handleViewportChange);
    }
    
    // Forzar un reflow después de un momento
    setTimeout(handleViewportChange, 100);
    
    return () => {
      window.removeEventListener('resize', handleViewportChange);
      window.removeEventListener('orientationchange', handleViewportChange);
      
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleViewportChange);
        window.visualViewport.removeEventListener('scroll', handleViewportChange);
      }
    };
  }, []);
  
  return null;
}

function App() {
  return (
    <ConfiguracionProvider>
      <UsersProvider>
        <LoadingProvider>
          <DialogProvider>
            <BrowserRouter>
              {/* Componente que maneja la altura del viewport */}
              <ViewportHandler />
              <Routes>
                {/* Rutas públicas */}
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/registro" element={<AplicarTutor />} />
                <Route path="/registroCliente" element={<RegistroCliente />} />

                <Route path="/registroCliente/verificar-numero" element={<ConfirmarNumero />} />
                <Route path="/registroCliente/verificar-correo" element={<ConfirmarCorreo />} />

                <Route path="/registroCliente" element={<RegistroCliente />} />


                <Route path="/registro/formulario" element={<Formulario />} />

                <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
                <Route path="/reestablecer" element={<CambiarContrasena />} />

                {/* Para pagar cotizacion sin login  */}
                <Route 
                  path="/pago/:nombreEmpresa/:idSolicitud/:marca" 
                  element={<DetallesSolicitudesGuest publicView={true} />} 
                />

                {/* Resultado de pago  */}
                {/* Manejar cotizaciones y manejar trabajos confirmados  */}
                <Route 
                  path="/pago/resultado/:idTransaccion/:pago" 
                  element={<PagoResultadoWompi/>} 
                />

                {/*  */}

                {/* Rutas protegidas */}
                <Route element={<ProtectedRoute />}>
                  {/* Ruta principal que contiene el HomeScreen con el sidebar */}
                  <Route path="/" element={<HomeScreenPrincipal />}>
                    {/* Subrutas que se renderizarán dentro de HomeScreenTutor */}
                    <Route index element={<Navigate to="/dashboard" replace />} />

                    <Route 
                        path="dashboard" 
                        element={
                          <ConditionalRoute 
                            tutorComponent={DashboardSolciitudesTutor}
                            adminComponent={DashboardAdminAdmin}
                            clienteComponent={SolicitudesCLiente}
                          />
                        } 
                      />     

                    <Route path="dashboard/tesis" element={<DashboardTesis />} />
                    <Route path="dashboard/tesis_manager" element={<TesisManager />} />

                    <Route path="configuracion" element={<ConfiguracionAdmin />} />


                    <Route path="recursos" element={<RecursosTutor />} />
                    <Route path="tesis_manager" element={<TesisManager />} />

                    <Route path="calendario" 
                      element={
                        <ConditionalRoute 
                          tutorComponent={Calendario}
                          adminComponent={CalendarioAdmin}
                        />
                        } 
                      />

                    <Route path="pagos" element={<PagosTutor />} />

                    <Route path="proPlataforma" element={<ProPlataformaDashboard />} />
                    <Route path="proPlataforma/agregar" element={<AgregarVariables />} />

                    <Route path="guardador" element={<GuardadorDatos />} />
                    <Route path="historial_solicitudes" element={<MisCotizaciones />} />
                    <Route path="dashboard/detalle_solicitud/:nombreEmpresa/:idSolicitud" element={<DetallesSolicitudes />} />
                    <Route path="dashboard/perfil" element={<PerfilUsuario />} />
                    <Route path="dashboard/plataforma" element={<ProPlataforma />} />
                    <Route path="dashboard/plataforma/:nombreEmpresa/:numeroCliente" element={<DetalleProPlataforma />} />

                    <Route path="tutores/" element={<ListaTutores />} />
                    <Route path="tutores/detalles_tutor/:nombreEmpresa/:uidTutor" element={<DetallesTutor />} />
                    <Route path="tutores/newtutores" element={<NuevosTutores />} />
                    <Route path="tutores/crearPruebas" element={<GeneradorPruebas />} />

                    <Route path="cuentasDeCobro" element={<ModeloCuentasCobro />} />

                    <Route path="estadisticas" element={<ModuloEstadisticas />} />
                    <Route path="estadisticas/marketing" element={<ModuloMarketing />} />
                    
                    <Route path="dashdashv2" element={<ModuloDashboard />} />

                    
                    <Route path="clientes" element={<ModuloClientes />} />
                    <Route path="clientes/detalle_cliente/:nombreEmpresa/:numeroCliente" element={<HistorialCliente />} />

                    <Route path="contabilidad" element={<ModuloContabilidad />} />
                    <Route path="contabilidad/detalles_servicio/:nombreEmpresa/:codigo" element={<DetallesServicio />} />
                    <Route path="contabilidad/detalles_servicio/:nombreEmpresa/:codigo/entregasParciales/:idEntrega" element={<DetallesEntregaTrabajo />} />
                    <Route path="contabilidad/costos" element={<ModuloCostos />} />
                    <Route path="contabilidad/registrar_pagos" element={<ModuloPagosParcial />} />


                    <Route path="whatsapp" element={<ModuloWhatsapp />} />
                    <Route path="whatsapp/embudo" element={<EmbudoVentas />} />

                    {/* Subrutas que se renderizarán dentro de HomeScreenAdmin */}
                    <Route path="dashboard/examen" element={<Prueba />} />

                    {/* Subrutas que se renderizarán dentro de HomeScreenAdmin */}
                    <Route index element={<Navigate to="/dashboardAdmin" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />

                  </Route>

                </Route>
                {/* Ruta de error para rutas inexistentes */}
                <Route path="*" element={<ErrorScreen />} />
              </Routes>
              <ToastContainer 
                position="top-right"
                autoClose={15000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </BrowserRouter>
          </DialogProvider>
        </LoadingProvider>
      </UsersProvider>
    </ConfiguracionProvider>
  );
}

export default App;